<mat-paginator
  hidePageSize
  showFirstLastButtons
  [length]="finalPayments.length"
  [pageSize]="1"
  [pageIndex]="currentIndex"
  (page)="browse($event)"
></mat-paginator>
